import { render, staticRenderFns } from "./TechInfoDetailsList.vue?vue&type=template&id=6f136520&scoped=true"
import script from "./TechInfoDetailsList.vue?vue&type=script&lang=js"
export * from "./TechInfoDetailsList.vue?vue&type=script&lang=js"
import style0 from "./TechInfoDetailsList.vue?vue&type=style&index=0&id=6f136520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f136520",
  null
  
)

export default component.exports